import { z } from 'zod';
import { LocaleSchema, TimestampSchema } from './common';

export const AuthProviderSchema = z.enum(['password', 'google']);
export type AuthProvider = z.infer<typeof AuthProviderSchema>;

/** users/{uid} profile doc (PRD §15.1). */
export const UserProfileSchema = z.object({
  uid: z.string().min(1),
  email: z.string().email(),
  name: z.string().trim().max(120).optional(),
  authProvider: AuthProviderSchema,
  locale: LocaleSchema.default('he'),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type UserProfile = z.infer<typeof UserProfileSchema>;
